import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { DetalheBaseController } from '../../helpers';
import { AcordoService, DevedorService, EmailService, LogSistemaService } from '../../services';
import { IOption } from 'ng-select';
import * as _ from 'underscore';
import * as moment from 'moment';
import { CurrencyPipe, DatePipe } from '@angular/common';
import {jsPDF} from 'jspdf';  
import html2canvas from 'html2canvas';  

@Component({
    selector: 'app-contrato',
    templateUrl: './contrato.component.html',
    styleUrls: ['./contrato.component.scss']
})

export class ContratoComponent extends DetalheBaseController implements OnInit {     
    @Input() contratoid: number;       
    acordos: any = [];
    dividas: any = [];
    parcelas: any = [];
    filtroDividas: any = [];
    dividasSource: any = [];  
    ClientesCobranca = [];  
    currentUser: any;    
    boletoId: String = "";    
    telefonesClienteCobranca: string ="";
    subAcordos: Subscription;
    subDividas: Subscription;
    subCliente: Subscription;
    showForm: boolean = false;
    novoAcordo: boolean = false;
    imprimirCarta: boolean = false;            
    dataCartaQuitacao: any = moment().locale('pt-br').format('LL');
    dataAtual: Date;

    contratoStatus: Array<IOption> = [
        { label: 'Em Aberto', value: '1' },
        { label: 'Negociado', value: '3' },
        { label: 'Liquidada', value: '2' }
    ];

    constructor(private router: Router, route: ActivatedRoute, private _acordoService: AcordoService, private _devedor: DevedorService,
        private _emailService: EmailService, private _logSistema: LogSistemaService, private datePipe: DatePipe, private currencyPipe: CurrencyPipe) {
        super(route, _acordoService);        
    }

    ngOnInit() {                     
        this.getDividas(this.contratoid);        
        this.currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));                
        this.getDadosClienteCobranca();
    }

    getDividas(contratoid: any) {
        this._loading.carregar();
        this.subDividas = this._devedor.getDividas(contratoid).subscribe(result => {
            let group = _.chain(result)
                .groupBy(e => e.contratoId)
                .map(e => (e[0].count = e.length, e[0])).value();

            this.parcelas = result;
            this.showForm = true;
            this.novoAcordo = contratoid > 0;
            if (result.length > 0 && result[0].acordoDivida != null) this.boletoId = result[0].acordoDivida.boletoId;
            let numero = 1;
            group.forEach(element => {

                element.ValorCalculadoJuros = this.calcularJuros(element);
                element.PorcetagemDesconto = this.calcularPorcentagemJuros(element, element.ValorCalculadoJuros );

                element.numeroDivida = numero;
                element.parcelas = this.ObterParcelas(element);   

                numero++;
            });

            this.dividasSource = group;
            this.dividas = this.dividasSource;
            this.formatarAcordos();            
            this._loading.fecharTodos();
        });
    }

    calcularJuros(divida) {
        var meses = divida.diasEmAtraso / 30;
        var taxa = 1.01;
        return divida.valorTotal *  (Math.pow(taxa, meses));
    }

    calcularPorcentagemJuros(divida, valorCalculadoJuros) {     
        return Math.round((( valorCalculadoJuros  - divida.valorTotal) / valorCalculadoJuros) * 100);
    }

    formatarAcordos() {
        
        this.acordos = [];
        let dividasPorAcordo = _.groupBy(this.dividas, (el: any) => {
            return el.acordoDivida != null ? el.acordoDivida.id : 0;
        });
        for (const key in dividasPorAcordo) {
            if (dividasPorAcordo.hasOwnProperty(key)) {
                let contratos = [];
                let valores = [];
                let valoresPuro = [];
                let datas = [];                
                let showcartaQuitacao: boolean = false;                
                let statusContrato: number = 0;
                let valorCalculadoJuros: number = 0;

                _.forEach(dividasPorAcordo[key], (divida) => {
                    contratos.push(divida.numeroContrato);
                    valores.push(this.currencyPipe.transform(divida.valorTotal, 'BRL', true));
                    valoresPuro.push(divida.valorTotal);
                    datas.push(this.datePipe.transform(divida.dataCadastro, 'dd/MM/yyyy'));      
                    statusContrato = divida.statusContrato;
                    this.dataAtual = divida.dataAtual;                    
                     
                    valorCalculadoJuros = this.calcularJuros(divida);
                    
                    if(divida.statusContrato == 2) {                        
                        showcartaQuitacao = this.exibirCartaQuitacao(divida.acordoDivida.pagamentoComCartao, 
                            divida.acordoDivida.ultimaDataPagamentoCartao);
                    }
                });
                this.acordos
                    .push({ 
                        acordoId: key, 
                        acordoDivida: dividasPorAcordo[key][0].acordoDivida, 
                        contratos: contratos.join(' | '), 
                        valores: valores.join(' | '), 
                        valorTotalAcordo: valoresPuro.reduce((a, b) => a + b, 0),
                        datas: datas.join(' | '), 
                        dividas: dividasPorAcordo[key],
                        statusContrato: statusContrato,                        
                        showcartaQuitacao: showcartaQuitacao,
                        valorCalculadoJuros: valorCalculadoJuros
                    });
            }
        }
    }

    obterDadosBoletoEmailRequest(boletoid: number, devedorid: number) {
        let dados = {
            boletoId: boletoid,
            devedorId: devedorid,
            email: ""
        };

        return dados;
    }

    obterDadosAcordoRequest(contratoid: number, parcela: number, desconto: number) {
        let dados = {
            contratoId: contratoid,
            numeroParcelaSelecionada: parcela,
            porcentagemDesconto: desconto
        };
        return dados;
    }

    postEmailSegundaViaBoleto(boletoid: number, devedorid: number) {
        this._devedor.getDevedorLogado().subscribe(result => {
            if (result.emailsAtivos.length <= 0) {
                localStorage.setItem('currentboleto', JSON.stringify(this.obterDadosBoletoEmailRequest(boletoid, devedorid)));
                this.router.navigate(['/app/boleto/email']);
            } else {
                this._emailService.postBoletoEmail(this.obterDadosBoletoEmailRequest(boletoid, devedorid)).subscribe(result => {
                    this.router.navigate(['/app/confirm']);
                });
            }
        });
    }

    getBoleto(url) {
        location.href = url;
        this.gravaLog("downloadBoleto", this._logSistema, this.boletoId);
    };

    CopiadoCodigoBarras() {
        this._notificationsService.Sucesso("Código de Barras", "Copiado para área de transferência.");
        this.gravaLog("copiarCodigoBarras", this._logSistema, this.boletoId);
    }

    postIncluirAcordo(divida) {
        this._dialog.confirm('Fazer Acordo', 'Confirmar o acordo para o contrato (' + divida.numeroContrato + ')?', () => {
            let parcela = this.parcelas.filter(x => x.contratoId == divida.contratoId && x.parcela == divida.quantidadeParcelasSelecionada);
            this._acordoService.postAcordo(this.obterDadosAcordoRequest(divida.contratoId, divida.quantidadeParcelasSelecionada, parcela.length > 0 ? parcela[0].descontoParcela : 20)).subscribe(result => {
                this._notificationsService.Sucesso("Dívida", "Acordo criado com sucesso!");
                this.router.navigate(['/app/home/' + divida.contratoId]);
            });
        });
    }

    ObterParcelas(divida) {
        let parcelas = [];
        let parcelaSelecionada = 1;

        divida.quantidadeParcelasSelecionada = parcelaSelecionada;
        for (let index = 1; index <= divida.numeroMaximoParcela; index++) {
            parcelas.push({ index: index, checked: index == parcelaSelecionada });
        }

        return parcelas;
    }

    onSelected(event) {
        this.filtroDividas.push(event.value);
        this.aplicarFiltro();
    }

    onDeselected(event) {
        this.filtroDividas = this.filtroDividas.filter(f => f != event.value).map(m => m);
        this.aplicarFiltro();
    }

    aplicarFiltro() {
        if (this.filtroDividas.length > 0)
            this.dividasSource.forEach(element => {
                element.visivel = this.filtroDividas.find(f => f == element.statusContrato) != undefined
            });
        else
            this.dividasSource.forEach(element => {
                element.visivel = true;
            });

        this.dividas = this.dividasSource.filter(x => x.visivel == true);
        this.formatarAcordos();
    }

    getParcelasDivida(contratoId) {
        return this.parcelas.filter(x => x.contratoId == contratoId);
    }

    ouvirLigacao = () => this.router.navigate(['/app/audio']);

    downloadcarta(divId: any) { 
        this.imprimirCarta = true;   
        setTimeout(function() {
            var element = document.getElementById(divId);       
            html2canvas(element).then(canvas => {                          
                var imgWidth = 208;   
                var pageHeight = 295;    
                var imgHeight = canvas.height * imgWidth / canvas.width;  
                var heightLeft = imgHeight;              
                const contentDataURL = canvas.toDataURL('image/png')  
                let pdf = new jsPDF('p', 'mm', 'a4'); // Orientação Retrato / milimetros / A4 size page of PDF  
                var position = 0;  
                pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)  
                pdf.save('CartaQuitacao.pdf');                 
                this.imprimirCarta = false;
            }); 
        }.bind(this), 500);         
    }

    exibirCartaQuitacao(pagamentoComCartao: boolean, ultimaDataPagamentoCartao: any) : boolean {                                
        if(pagamentoComCartao) {                          
            return this.calcularDiasEntreDatas(ultimaDataPagamentoCartao, this.dataAtual) > 30;                    
        }
        return true;            
    }  
    
    calcularDiasEntreDatas(date1, date2) {
        moment.locale('pt-br');   
        var data1 = moment(this.datePipe.transform(date1, 'dd/MM/yyyy'),'DD/MM/YYYY');        
        var data2 = moment(this.datePipe.transform(date2, 'dd/MM/yyyy'),'DD/MM/YYYY');

        var diferenca  = data2.diff(data1, 'days');  
        return diferenca;        
    }

    getDadosClienteCobranca() {        
        this.subCliente = this._devedor.getClienteTelefonesPorClienteId(this.currentUser.clienteid).subscribe(result => {
            result.forEach(element => {                    
                this.ClientesCobranca.push(this.formataTelefone(String(element.numeroTelefone)));                              
            });  
            this.telefonesClienteCobranca = this.ClientesCobranca.join(', ');            
        });        
      }

    ngOnDestroy() {
        if (this.subAcordos) this.subAcordos.unsubscribe();
        if (this.subDividas) this.subDividas.unsubscribe();
        if (this.subCliente) this.subCliente.unsubscribe();
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/contrato/contrato.component.ts